<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="formInline" class="demo-form-inline" ref="searchform">
						<el-form-item label="标题" prop="title">
							<el-input placeholder="标题" v-model="formInline.title"></el-input>
						</el-form-item>
						<el-form-item label="状态" prop="status">
							<el-select placeholder="状态" v-model="formInline.status">
								<el-option label="已发送" value="1"></el-option>
								<el-option label="未发送" value="2"></el-option>
								<el-option label="已删除" value="3"></el-option>
								<el-option label="已撤回" value="4"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button @click="seachFun" type="primary">{{ $t('device.inquire')  }}</el-button>
							<el-button @click="resetFun" type="primary">{{ $t('device.reset')  }}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-button @click="addUser" type="primary" v-if="$store.state.pageAction.indexOf('message.add')>  -1">
					{{ $t('device.add')  }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="标题" prop="title"></el-table-column>
				<el-table-column label="接收人" prop="receiver_list"></el-table-column>
				<el-table-column label="状态" prop="status_title"></el-table-column>
				<el-table-column label="允许回复" prop="is_comment_title"></el-table-column>
				<el-table-column label="生效时间" prop="expire_at" width="160"></el-table-column>
				<el-table-column label="发送时间" prop="send_at" width="160"></el-table-column>
				<el-table-column label="创建时间" prop="create_at" width="160"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="280">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small"
							v-if="$store.state.pageAction.indexOf('message.edit')>  -1">{{ $t('message.edit')  }}
						</el-button>
						<el-button @click="handleSend(scope.row)" type="info" size="small"
							v-if="scope.row.status==2&&$store.state.pageAction.indexOf('message.send')>  -1">发送
						</el-button>
						<el-button @click="handleWithdraw(scope.row)" type="danger" size="small"
							v-if="scope.row.status==1&&$store.state.pageAction.indexOf('message.delete')>  -1">撤回
						</el-button>
						<el-button @click="handleDelete(scope.row)" type="danger" size="small"
							v-if="scope.row.status<=2&&$store.state.pageAction.indexOf('message.delete')>  -1">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" v-model="addPop" width="50%" class="message-dialog">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<el-form-item label="标题" label-width="120px" prop="title">
						<el-input v-model="addForm.title"></el-input>
					</el-form-item>
					<el-form-item label="内容" label-width="120px" prop="content">
						<div class="editor-container">
							<QuillEditor ref="quillEditor" v-model:content="addForm.content" content-type="html"
								:options="editorOption" class="quill-editor" @update:content="handleEditorChange" />
						</div>
					</el-form-item>

					<el-form-item label="允许回复" label-width="120px" prop="is_comment">
						<el-select v-model="addForm.is_comment" placeholder="请选择" style="width: 160px !important;">
							<el-option label="是" :value="1"></el-option>
							<el-option label="否" :value="2"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="生效时间" label-width="120px" prop="expire_at">
						<el-date-picker type="datetime" v-model="addForm.expire_at" :disabled-date="disabledDate"
							value-format="YYYY-MM-DD HH:mm:ss" append-to-body clearable
							popper-class="custom-datepicker"></el-date-picker>
					</el-form-item>

					<div style="display: flex; gap: 20px;">
						<el-form-item label="接收人" label-width="120px" prop="client_id">
							<el-cascader :options="clientOpts" placeholder="组织"
								v-model="addForm.client_id"></el-cascader>
						</el-form-item>

						<el-form-item label="" label-width="80px" prop="role_id">
							<div style="display: flex; align-items: center; gap: 30px;">
								<el-select placeholder="角色" v-model="addForm.role_id">
									<el-option :key="item.value" :label="item.label" :value="item.value"
										v-for="item in roleOpts"></el-option>
								</el-select>
								<el-button type="primary" @click="handleAddGroup">添加</el-button>
							</div>
						</el-form-item>
					</div>
					<!-- 新增标签展示区域 -->
					<div style="margin-top: 20px;margin-left: 100px;">
						<span v-for="(group, index) in selectedGroups" :key="index" class="tag-item">
							{{ getClientLabel(index)  }} - {{ getRoleLabel(index)  }}
							<i class="el-icon-close" @click="handleRemoveGroup(index)">X</i>
						</span>
					</div>

				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel')  }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm')  }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import message from "../../model/message";
	import role from "../../model/role";
	import client from "../../model/client";
	import device from "@/model/device";
	import {
		QuillEditor
	} from '@vueup/vue-quill'
	import '@vueup/vue-quill/dist/vue-quill.snow.css';

	export default {
		name: "user",
		components: {
			QuillEditor
		},
		data() {
			return {
				loadings: false,
				dialogFormVisible: false,
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
								[{ 'color': ['#000000', '#FF0000', '#616161', '#9E9E9E', '#E0E0E0', '#2F5496','#D7D31','#52C41A','#FAAD14','#A5A5A5','#FF4D4F'] }], // 预设颜色+自定义
								[{
									header: 1
								}, {
									header: 2
								}], // 1、2 级标题
								[{
									list: 'ordered'
								}, {
									list: 'bullet'
								}], // 有序、无序列表
								[{
									script: 'sub'
								}, {
									script: 'super'
								}], // 上标/下标
								[{
									indent: '-1'
								}, {
									indent: '+1'
								}], // 缩进
								[{
									direction: 'rtl'
								}], // 文本方向
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}], // 标题
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								['clean'], // 清除文本格式
								['link', 'image'] // 链接、图
							], // 链接、图片、视频 
							handlers: {
								'image': this.imageHandler   // 修改为使用自定义图片处理方法
							}
						}
					},
					placeholder: ''
				},
				formInline: {
					title: "",
					status: "",
					page: 1,
					size: 10
				},
				resetform: {
					uid: "",
					title: "",
					password: ""
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					type: 1,
					title: "",
					expire_at: "",
					content: "",
					receiver: [],
					is_comment: 2,
					client_id: [],
					role_id: ""
				},
				selectedGroups: [],
				roleOpts: [],
				clientOpts: [],
				clientListOpts: [],
				rules: {
					title: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					content: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					is_comment: [{
						required: true,
						message: '请选择是否允许回复',
						trigger: 'blur'
					}],
					expire_at: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					client_id: [{
						required: false,
						message: this.$t('role.select_customer'),
						trigger: "blur"
					}],
					role_id: [{
						required: false,
						message: this.$t('role.select_group'),
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			this.loadRole();
			this.loadClient();
		},
		methods: {
			handleEditorChange(content) {
				this.addForm.content = content;
			},
			resetFun() {
				this.formInline.title = ''
				this.formInline.status = ''
				this.loadData()
			},
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,   limit)}...` : text || '-';
			},
			// 添加组合 
			handleAddGroup() {
				if (!this.addForm.client_id || this.addForm.client_id.length === 0 || !this.addForm.role_id) {
					this.$message.warning(' 请选择组织角色');
					return;
				}

				let client_id = this.addForm.client_id[this.addForm.client_id.length - 1];
				console.log(this.addForm.client_id)

				const newGroup = {
					client_id: client_id,
					client_name: this.clientListOpts.find(item => item.value === client_id)?.label,
					role_id: this.addForm.role_id,
					role_name: this.roleOpts.find(item => item.value === this.addForm.role_id)?.label
				};

				this.selectedGroups.push(newGroup);
				// 清空选择 
				this.addForm.client_id = [];
				this.addForm.role_id = '';
			},
			handleRemoveGroup(index) {
				this.selectedGroups.splice(index, 1);
			},
			// 获取设备托管的显示文本 
			getClientLabel(i) {
				return this.selectedGroups[i]?.client_name;
			},

			// 获取角色组的显示文本 
			getRoleLabel(i) {
				return this.selectedGroups[i]?.role_name;
			},
			async loadData() {
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async loadRole() {
				const ret = await role.map({})
				if (ret.code === 200) {
					ret.data.forEach(v => {
						this.roleOpts.push({
							value: v.id,
							label: v.title
						})
					})
				}
			},
			// 新增图片处理方法
			async imageHandler() {
				const input = document.createElement('input');
				input.setAttribute('type', 'file');
				input.setAttribute('accept', 'image/*');
				input.click();

				input.onchange = async () => {
					const file = input.files[0];
					if (!file) return;

					try {

						// 复用上传逻辑
						let formData = new FormData();
						formData.append("file", file);

						const ret = await device.uploadFile(formData);
						if (ret.code === 200) {
							const quill = this.$refs.quillEditor.getQuill();
							const range = quill.getSelection(true);
							quill.insertEmbed(range.index, 'image', ret.data);
							quill.setSelection(range.index + 1);
						} else {
							this.$message.error(' 图片上传失败: ' + ret.message);
						}

					} catch (error) {
						this.$message.error(' 图片上传出错: ' + error.message);
					}
				};
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					ret.data.forEach(i => {
						let options = {
							value: i.id,
							label: i.name,
							children: []
						};
						this.clientListOpts.push({
							value: i.id,
							label: i.name
						});

						if (i.children.length > 0) {
							this.clientOpts.push({
								value: i.id,
								label: i.name
							});
							i.children.forEach(v => {
								let opts = {
									value: v.id,
									label: v.name
								};
								this.clientListOpts.push({
									value: v.id,
									label: v.name
								});

								if (v.children.length > 0) {
									options.children.push({
										value: v.id,
										label: v.name
									});
									opts.children = [];
									v.children.forEach(item => {
										let children = {
											value: item.id,
											label: item.name,
										};
										this.clientListOpts.push({
											value: item.id,
											label: item.name
										});

										if (item.children.length > 0) {
											children.children = [];
											item.children.forEach(val => {
												children.children.push({
													value: val.id,
													label: val.name
												});
												this.clientListOpts.push({
													value: val.id,
													label: val.name
												});
											})
										}
										opts.children.push(children);
									});
								}
								options.children.push(opts);
							});
						}
						this.clientOpts.push(options);
					});
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						params.receiver = JSON.stringify(this.selectedGroups)
						const ret = await message.save(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			async handleStatus(row) {
				const ret = await message.status({
					uid: row.uid,
					status: row.status == 1 ? 2 : 1
				})
				if (ret.code === 200) {
					this.$message.success(ret.message)
					this.loadData()
				} else {
					this.$message.warning(ret.message)
				}
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				this.$nextTick(() => {
					this.$refs.addForm?.resetFields();
					this.addForm = {
						type: 1,
						title: "",
						expire_at: "",
						content: "",
						receiver: [],
						is_comment: 2,
						client_id: [],
						role_id: ""
					};
					this.selectedGroups = [];
					if (this.$refs.quillEditor) {
						this.$refs.quillEditor.setHTML('');
					}
				});
			},
			handleEdit(row) {
				this.addPop = true;
				this.$nextTick(() => {
					this.$refs.addForm?.resetFields();
					let rowData = JSON.parse(JSON.stringify(row));
					this.addForm = {
						...rowData,
						client_id: [],
						role_id: ""
					};
					this.selectedGroups = JSON.parse(rowData.receiver || '[]');
					if (this.$refs.quillEditor) {
						this.$refs.quillEditor.setHTML(rowData.content || '');
					}
				});
			},
			async handleSend(row) {
				this.$confirm('此操作将给所有发送人发送消息', '发送', {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.send({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success(' 操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					})
			},
			async handleWithdraw(row) {
				this.$confirm('此操作将撤回已发送消息', '撤回', {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.withdraw({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success(' 操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success(' 操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}

	.editor-container {
		width: 100%;
		margin-bottom: 20px;
	}

	/* 使用 ::v-deep 或 :deep() 穿透 scoped 限制 */
	:deep(.ql-container) {
		height: 200px !important;
		white-space: pre-wrap;
	}

	.message-dialog {
		max-height: 100vh;
		overflow-y: auto;
	}

	.message-dialog .el-dialog__body {
		padding-bottom: 20px;
	}
</style>